import { SCREEN } from '../../utils/constants';

import {navigate } from './movePages';
import { hideFutureSpecialsOptIn, isInInstantQuote, setEmail, setEmailCheck } from '../../utils/variables';
import validator from 'validator';
import { newPhoneUI, oldPhoneUI } from '../actions/phoneActions';

export function emailListeners() {
  validateEmail();
  onCheckEmail();

  const emailOptInWrapper = document.querySelector(
    '.email__container .emailCheckbox__wrapper'
  );
  if (emailOptInWrapper) {
    emailOptInWrapper.classList.toggle('hide', hideFutureSpecialsOptIn);
    if (hideFutureSpecialsOptIn) {
      const checkBox = document.querySelector(
        '.email__container .email__checkbox'
      );
      checkBox?.classList.remove('is-checked');
      setEmailCheck(false);
    }
  }

  const emailElement = document.querySelector('.email__container .email');
  if (emailElement) {
    emailElement.addEventListener('click', (e) => {
      const emailInput = document.getElementById('email');
      if (emailInput) {
        emailInput.focus();
      }

      e.preventDefault();
      let error = false;
      let input = document.querySelector('.email--input');

      if (
        !input.value ||
        (input.getAttribute('id') === 'email' &&
          !validator.isEmail(input.value))
      ) {
        input.classList.add('invalid');
        error = true;
      }
      if (error) {
        return;
      }
    });
  }

  /* On click enter */
  const screenEmail = document
    .querySelector('.screen--email');

  if (screenEmail) {
    screenEmail.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && !document
        .querySelector('.emailContinue__btn').classList.contains('disabled')) {
        document
          .querySelector('.emailContinue__btn').click();
      }
    });
  }

  /* on click Continue after select fullName */
  document
    .querySelector('.emailContinue__btn')
    .addEventListener('click', async () => {
      if (isInInstantQuote) {
        oldPhoneUI();
      } else {
        newPhoneUI();
      }
      navigate(SCREEN.PHONE);
      setTimeout(() => {
        const phoneInput = document.getElementById('phone');
        if (phoneInput !== document.activeElement) {
          phoneInput.focus();
        }
      }, 400);
    });

  /* on click back */
  document
    .querySelector('.emailBack__btn')
    .addEventListener('click', async () => {
      setTimeout(() => {
        const fullNameInput = document.getElementById('fullName');
        if (fullNameInput !== document.activeElement) {
          fullNameInput.focus();
        }
      }, 400);
    });
}

function validateEmail() {
  const email = document.querySelector('#email');
  const emailWrap = document.querySelector('.email');
  const invalidIcon = document.querySelector('.email__invalid');
  const validIcon = document.querySelector('.email__valid');
  email.oninput = (e) => {
    setEmail(e.target.value);
    if (validator.isEmail(e.target.value)) {
      emailWrap.classList.add('valid');
      emailWrap.classList.remove('invalid');
      invalidIcon.classList.add('hidden');
      email.classList.remove('invalid');
      validIcon.classList.remove('hidden');
      document
        .querySelector('.emailContinue__btn')
        .classList.remove('disabled');
    } else {
      emailWrap.classList.remove('valid');
      emailWrap.classList.add('invalid');
      invalidIcon.classList.remove('hidden');
      document
        .querySelector('.emailContinue__btn')
        .classList.add('disabled');
    }
  };
}

function onCheckEmail() {
  const checkBox = document.querySelector(
    '.email__container .email__checkbox'
  );

  checkBox.onclick = () => {
    if (checkBox.classList.contains('is-checked')) {
      checkBox.classList.remove('is-checked');
      setEmailCheck(false);
    } else {
      checkBox.classList.add('is-checked');
      setEmailCheck(true);
    }
  };
}
